import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { Environment } from 'dashboard/models/environment';
import { Transaction } from 'dashboard/models/transaction';
import Action from 'lib/interfaces/Action';
import { PaginationParams } from 'lib/interfaces/api';
import { Iso8601DateString } from 'lib/types';

interface SetTransactionsPayload {
  transactions: Transaction[];
  environment: Environment;
  paginationParams: PaginationParams;
}

export interface TransactionsFilterParams {
  createdAtStart?: Iso8601DateString;
  createdAtEnd?: Iso8601DateString;
  omni?: string;
  tagIds?: string[];
  transactionTypeIds?: string[];
  transactionStatusIds?: string[];
  listIds?: string[];
}

interface TransactionsFiltersPayload {
  filters: TransactionsFilterParams;
}

interface TransactionsSortParamsPayload {
  sortParams: SortParams;
}

interface CurrentPagePayload {
  currentPage: number;
}

interface PageSizePayload {
  pageSize: number;
}

export type TransactionsActions =
  | Action<TransactionsActionType.SetTransactions, SetTransactionsPayload>
  | Action<TransactionsActionType.SetSortParams, TransactionsSortParamsPayload>
  | Action<TransactionsActionType.SetFilters, TransactionsFiltersPayload>
  | Action<TransactionsActionType.SetCurrentPage, CurrentPagePayload>
  | Action<TransactionsActionType.SetPageSize, PageSizePayload>;

export enum TransactionsActionType {
  SetTransactions = 'transactions/SET_TRANSACTIONS',
  SetCurrentPage = 'transactions/SET_CURRENT_PAGE',
  SetPageSize = 'transactions/SET_PAGE_SIZE',
  SetSortParams = 'transactions/SET_SORT_PARAMS',
  SetFilters = 'transactions/SET_FILTERS',
}

export function setTransactions(
  transactions: SetTransactionsPayload['transactions'],
  environment: SetTransactionsPayload['environment'],
  paginationParams: SetTransactionsPayload['paginationParams'],
): Action<TransactionsActionType.SetTransactions, SetTransactionsPayload> {
  return {
    payload: {
      transactions,
      environment,
      paginationParams,
    },
    type: TransactionsActionType.SetTransactions,
  };
}

export function setCurrentPage(
  currentPage: number,
): Action<TransactionsActionType.SetCurrentPage, CurrentPagePayload> {
  return {
    payload: {
      currentPage,
    },
    type: TransactionsActionType.SetCurrentPage,
  };
}

export function setPageSize(
  pageSize: number,
): Action<TransactionsActionType.SetPageSize, PageSizePayload> {
  return {
    payload: {
      pageSize,
    },
    type: TransactionsActionType.SetPageSize,
  };
}

export function setFilters(
  filters: TransactionsFilterParams,
): Action<TransactionsActionType.SetFilters, TransactionsFiltersPayload> {
  return {
    payload: {
      filters,
    },
    type: TransactionsActionType.SetFilters,
  };
}

export function setSortParams(
  sortParams: SortParams,
): Action<TransactionsActionType.SetSortParams, TransactionsSortParamsPayload> {
  return {
    payload: {
      sortParams,
    },
    type: TransactionsActionType.SetSortParams,
  };
}
